export const handleDownloadFile = (url: string): void => {
  const link = document.createElement('a');
  const val: any = null;
  link.setAttribute('download', val);
  link.style.display = 'none';
  document.body.appendChild(link);
  link.setAttribute('href', url);
  link.click();
  document.body.removeChild(link);
};
